import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

interface IProps {
    serviceList: string[];
    selectedCountry?: string;
    showDisclosureStatus: any;
}

const WhatYouNeedToKnow: React.FunctionComponent<IProps> = (props) => {
    const [show, setShow] = useState(true);
    const { t: tLang, i18n: i18nLang } = useTranslation();

    const productListToShowThisSection = [
        "SVC-CRDSCORE-1B", //Quarterly Credit Score
        "SVC-CRDSCORE-1B-MONTHLY", //Monthly Credit Score
        "SVC-CRDSCORE-1B-PARENT", //Credit Score
        "SVC-EXP-MCST", //Credit Score Tracker
        "SVCLVL-CRDRPT-3B-SCORE", //3-Bureau Credit Report & Score
        "SVCLVL-CRDRPT-EQUI-SCORE", //Equifax Credit Report with Score
        "SVCLVL-CRDRPT-EXP-SCORE", //Experian Credit Report with Score
        "SVCLVL-CRDRPT-TRANS-SCORE", //Experian Credit Report with Score
        "SVCLVL-CS-TU-CRDSCORE-VTG-1B", //Credit Score
        "SVCLVL-EXP-ACRDRPT-3B-SCORE", //3-Bureau Annual Credit Report & Score
        "SVCLVL-EXP-ACRDRPT-SCORE", //1-Bureau Annual Credit Report & Score
        "SVCLVL-EXP-OTCRDRPT-3B-SCORE", //3-Bureau One Time Credit Report & Score
        "SVCLVL-EXP-OTCRDRPT-SCORE", //1-Bureau One Time Credit Report & Score
        "SVCLVL-TU-ACRDRPT-3B-SCORE", //3-Bureau Annual Credit Report & Score
        "SVCLVL-TU-ACRDRPT-SCORE", //1-Bureau Annual Credit Report & Score
        "SVCLVL-TU-CRDRPT-3B-SCORE", //3-Bureau Credit Report & Score
        "SVCLVL-TU-CRDRPT-SCORE", //1-Bureau Credit Report & Score
        "SVCLVL-TU-MCRDRPT-3B-SCORE", //3-Bureau Monthly Credit Report & Score
        "SVCLVL-TU-MCRDRPT-SCORE", //1-Bureau Monthly Credit Report & Score
        "SVCLVL-TU-QCRDRPT-3B-SCORE", //3-Bureau Quarterly Credit Report & Score
        "SVCLVL-TU-QCRDRPT-SCORE", //1-Bureau Quarterly Credit Report & Score
        "SVC-TU-ACRDSCORE-1B", //Annual Credit Score
        "SVC-TU-CRDRPT-SCORE-1B-ONETIME", //1B Credit Report & Score
        "SVC-TU-CRDRPT-SCORE-3B-ONETIME", //3B Credit Report & Score
        "SVC-TU-CSS", //Credit Score Simulator
        "SVC-TU-CST", //Credit Score Tracker
        "SVC-TU-DCRDSCORE-1B", //Daily Credit Score
        "SVC-TU-MCRDSCORE-1B", //Monthly Credit Score
        "SVC-TU-QCRDSCORE-1B", //Quarterly Credit Score
    ];

    
    useEffect(() => {
        let found = false;
        props.serviceList.forEach((service) => {
                if (service != null && service.trim().length > 0 && service !== "--") {
                    if (!found) {
                        found = productListToShowThisSection.find((element) => element === service) != null;
                    }
                 }
         });
        setShow(found);
        props.showDisclosureStatus(found);

    }, [props]);
    return (
        <>
            {show && props.selectedCountry === "US" && (
                <>
                    <div className="wyntk-content">
                        Your credit score is calculated based on the <span style={{ fontWeight: "bold" }}>VantageScore® 3.0 model</span>.  Lenders and insurers may use different scores to evaluate your eligibility.
                    </div>
                </>
            )}
        </>
    );
};
export default WhatYouNeedToKnow;
